

























































import Vue from 'vue'
import iNoBounce from 'inobounce'
import axios from 'axios'
import qs from 'qs'

import BaseHeader from '../components/Base/Header.vue'
import BaseButton from '../components/Base/Button.vue'
import FileSelector from '../components/FileSelector.vue'

import {Shape, Current} from '../interface'
import types from '../store/types'

export default Vue.extend({

  components: {
    BaseHeader,
    BaseButton,
    FileSelector
  },

  data() {
    return {
      createSeed: '',
      badgeLength: 0,
      loadedLength: 0,
      displayDownload: false
    }
  },

  computed: {
    badgeList(): Current[] {
      return this.$store.state.BadgeList.list
    },
    shapeList(): Shape[] {
      return this.$store.state.Shape.list
    }
  },

  beforeCreate() {
    iNoBounce.disable()

    if (this.$store.state.BadgeList.list.length === 0) {
      this.$router.push('editor')
      return
    }
  },

  destroyed() {
    iNoBounce.enable()
  },

  methods: {
    selectBadge(index: number): void {
      const list: Current[] = this.$store.state.BadgeList.list
      if (! list[index]) {
        return
      }

      this.$store.commit(types.mutations.BADGE_LIST_SELECTED, index)
      this.$store.commit(types.mutations.CURRENT_UPDATE, list[index])
      this.$router.push('editor')
    },
    deleteBadge(index: number): void {
      if (window.confirm('削除してもよろしいですか？')) {
        this.$store.commit(types.mutations.BADGE_LIST_DELETE, index)
      }
    },
    selectFile(e: FileReader | null) {
      this.$store.commit(types.mutations.CURRENT_INIT)
      this.$store.commit(types.mutations.BADGE_LIST_SELECTED, -1)
      this.$store.commit(types.mutations.CURRENT_FILE, e)
      this.$router.push('editor')
    },
    prepareCreating() {
      this.$store.commit(types.mutations.APP_LOADING_TEXT, '入稿データの作成準備をしています')
      this.$store.commit(types.mutations.APP_LOADING, true)

      const url = './php/handler.php?mode=prepare'
      axios({
        method: 'post',
        url
      })
        .then((result) => {
          this.createSeed = result.data.data.seed

          this.createData()
        })
        .catch((error) => {
          window.alert('入稿ファイルの作成に失敗しました')
          this.$store.commit(types.mutations.APP_LOADING, false)

          console.log(error)
        })
    },
    createData() {
      const badgeLength: number = this.$store.state.BadgeList.list.length
      this.badgeLength = badgeLength
      this.loadedLength = 0
      if (! badgeLength) {
        this.$store.commit(types.mutations.APP_LOADING, false)
        window.alert('缶バッジデザインが登録されていません')
        return
      }
      this.displayLoadingMessage(0)

      const promiseList: any[] = []
      this.$store.state.BadgeList.list
        .forEach((badge: Current, key: number) => {
          promiseList.push(this.createImage(key))
        })

      Promise.all(promiseList)
        .then(() => {
          // this.$store.commit(types.mutations.APP_LOADING, false)
          this.$store.commit(types.mutations.APP_LOADING_TEXT, '入稿データを圧縮しています')

          // const url: string = './php/handler.php?mode=compress&number=' + badgeLength
          // window.location.href = url
          // window.open(url)
          const url: string = './php/handler.php?mode=compress'
          axios({
            method: 'post',
            url,
            data: qs.stringify({
              seed: this.createSeed,
              number: badgeLength
            }),
            headers: {
              'Content-type': 'application/x-www-form-urlencoded'
            }
          })
            .then(() => {
              this.$store.commit(types.mutations.APP_LOADING, false)
              this.displayDownload = true
            })
            .catch((e) => {
              this.$store.commit(types.mutations.APP_LOADING, false)
              window.alert('入稿データの圧縮に失敗しました')
              console.log(e)
            })
        })
        .catch((e) => {
          this.$store.commit(types.mutations.APP_LOADING, false)
          window.alert('缶バッジデザインの作成に失敗しました')
          console.log(e)
        })
    },
    createImage(index: number) {
      const url: string = './php/handler.php?mode=create'

      return new Promise((resolve, reject) => {
        if (! this.$store.state.BadgeList.list[index]) {
          reject('Not found Badge data : ' + index)
        }
        const badge: Current = this.$store.state.BadgeList.list[index]

        const data = {
          file: badge.file!.result,
          x: badge.x,
          y: badge.y,
          scale: badge.scale,
          rotate: badge.rotate,
          shape: {...this.shapeList[badge.shape]},
          number: badge.number,
          index,
          seed: this.createSeed
        }

        axios({
          method: 'post',
          url,
          data: qs.stringify(data),
          headers: {
            'Content-type': 'application/x-www-form-urlencoded'
          }
        })
          .then(() => {
            this.displayLoadingMessage(1)
            resolve('created image')
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    displayLoadingMessage(count: number): void {
      this.loadedLength += count

      const message: string =
        '入稿データを作成しています' +
        this.loadedLength + '/' +
        this.badgeLength

      this.$store.commit(types.mutations.APP_LOADING_TEXT, message)
    },
    downloadLink(): void {
      if (window.hasOwnProperty('ga')) {
        (window as any).ga('send', 'event', 'simulator', 'click', 'download')
      }

      const compress = this.shapeList[this.badgeList[0].shape].compress
      const url = './php/handler.php?mode=download&seed=' + this.createSeed + '&name=' + compress
      window.open(url)
    },
    hideDownloadLink(): void {
      this.displayDownload = false
    },
    changeMaterial(): void {
      if (window.confirm('登録したデザインデータも削除されますが、よろしいですか？')) {
        // Initialize data
        this.$store.commit(types.mutations.CURRENT_INIT_ALL)
        this.$store.commit(types.mutations.BADGE_LIST_INIT)

        this.$router.push('material')
      }
    }
  }

})
